var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBacktick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.0327 23.9192C33.8726 23.9337 34.5652 23.2646 34.5797 22.4247C34.5942 21.5848 33.9251 20.8922 33.0852 20.8777L33.0327 23.9192ZM8.94321 20.9066C8.33906 21.4902 8.32244 22.4531 8.90609 23.0573L18.4172 32.9024C19.0009 33.5066 19.9638 33.5232 20.5679 32.9396C21.1721 32.3559 21.1887 31.393 20.605 30.7889L12.1507 22.0376L20.902 13.5833C21.5061 12.9996 21.5227 12.0367 20.9391 11.4326C20.3554 10.8284 19.3925 10.8118 18.7884 11.3955L8.94321 20.9066ZM33.0852 20.8777L10.0262 20.4797L9.97376 23.5213L33.0327 23.9192L33.0852 20.8777Z",
    fill: "rgba(29, 29, 29, 0.75)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBacktick);
export default __webpack_public_path__ + "static/media/backtick.586681457c684c27e6b1c9e2376801ea.svg";
export { ForwardRef as ReactComponent };